import React from 'react'
import Clock from 'react-live-clock'

class TimeComponent extends React.Component {
  render () {
    return (
      <div>
        <div style={styles.content}>
          <Clock style={styles.label} format={'HH'} ticking={true} timezone={'Indian/Antananarivo'} /><br />
          <Clock style={styles.label} format={'mm'} ticking={true} timezone={'Indian/Antananarivo'} />
        </div>
      </div>
    )
  }
}

const styles = {
  content: {
    marginTop: '7px',
    height: '60px'
  },
  label: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  }
}

export default TimeComponent
